import $ from 'jquery';

$(function () {
  var $table = $('.range-table');
  var $prev = $('#prev');
  var $next = $('#next');
  var cellWidth = 270;
  var scrollAmount;
  var scrollRemainder;

  $prev.on('click', function () {
    $prev.attr('disabled', true);

    scrollRemainder = $table.scrollLeft() % cellWidth;

    if (scrollRemainder) {
      scrollAmount = scrollRemainder;
    } else {
      scrollAmount = cellWidth;
    }

    $table.animate(
      {
        scrollLeft: '-=' + scrollAmount + 'px',
      },
      300,
    );

    setTimeout(function () {
      $prev.attr('disabled', false);
    }, 300);
  });

  $next.on('click', function () {
    $next.attr('disabled', true);

    scrollRemainder = $table.scrollLeft() % cellWidth;

    if (scrollRemainder) {
      scrollAmount = cellWidth - scrollRemainder;
    } else {
      scrollAmount = cellWidth;
    }

    $table.animate(
      {
        scrollLeft: '+=' + scrollAmount + 'px',
      },
      300,
    );

    setTimeout(function () {
      $next.attr('disabled', false);
    }, 300);
  });

  const tables = document.querySelectorAll('.range-table');

  let observer;

  let options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5,
  };

  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        setTimeout(function () {
          entry.target.classList.add('range-table--visible');
        }, 600);
        observer.unobserve(entry.target);
      }
    });
  }, options);

  tables.forEach((table) => {
    observer.observe(table);
  });
});
